import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_drafts",
  "use": "svg_drafts-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 14\" id=\"svg_drafts\"><path d=\"M.75 1h6m-6 3h16.5M.75 7h4.5m-4.5 3h9M7.5 7h9.75m-4.5 3h4.5M.75 13h1.5m3 0h3\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol